<template>
  <a-modal
    v-model="visible"
    title="编辑"
    centered
    width="400px"
    destroyOnClose
    :keyboard="false"
    :maskClosable="false"
    @cancel="handleCancel"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    :getContainer="getContainer"
  >
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="课时" prop="class_number">
        <a-input-number
          style="width: 100%"
          id="inputNumber"
          v-model="form.class_number"
          :min="0"
          :max="999"
        />
      </a-form-model-item>
      <a-form-model-item label="分数" prop="score">
        <a-input-number
          style="width: 100%"
          id="inputNumber"
          v-model="form.score"
          :min="0"
          :max="100"
        />
      </a-form-model-item>
      <!-- <a-form-model-item label="是否合格" prop="score">
        <a-radio-group name="radioGroup" v-model="form.pass_type">
          <a-radio :value="1" style="display: block;line-height: 40px;height: 40px;color: red;"> 不合格（红码） </a-radio>
          <a-radio :value="2" style="display: block;line-height: 40px;height: 40px;color: orange;"> 及格（黄码） </a-radio>
          <a-radio :value="3" style="display: block;line-height: 40px;height: 40px;color: green;">优秀（绿码） </a-radio>
        </a-radio-group>
      </a-form-model-item> -->
    </a-form-model>
  </a-modal>
</template>

<script>
import { trainEdit } from "@/request/classes";
export default {
  data() {
    return {
      confirmLoading: false,
      visible: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      form: {
        id: "",
        class_number: "",
        score: "",
        // pass_type: "",
      },
      rules: {
        class_number: [
          {
            required: true,
            message: "请输入课时",
            trigger: "blur",
          },
        ],
        score: [
          {
            required: true,
            message: "请输入分数",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    init(e) {
      this.visible = true;
      this.form.id = e.id;
      this.form.class_number = e.class_number;
      this.form.score = e.score;
      // this.form.pass_type = e.pass_type;
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          trainEdit(this.form)
            .then(() => {
              this.$message.success("修改成功");
              this.$emit("ok");
              this.handleCancel();
            })
            .finally(() => {
              this.confirmLoading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleCancel() {
      this.visible = false;
    },
    getContainer(){
      return document.getElementById("bodyContnet")
    }
  },
};
</script>

<style>
</style>